import AssetLibrary from "../assets/asset-library";
import ensureArray from '../utils/ensure-array';

const MeshIsolation = new class MeshIsolation {
    constructor() { }

    show(objectUuids, opacity = 0.2, duration = 0.2) {
        this.saveTransparency();

        //fade out last action if exists
        this.end();

        //fade in new action
        const clip = createAnimationClip(objectUuids, opacity);
        this.action = Q3.mixer.clipAction(clip);
        this.action.play();
        this.action.fadeDuration = duration;
        this.action.fadeIn(duration);
    }

    end() {
        if (this.action) {
            this.action.fadeOut(this.action.fadeDuration);
            const _action = this.action;
            setTimeout(() => {
                _action.stop();
                if (!this.action) { this.recoverTransparency(); }

            }, this.action.fadeDuration * 1000);
            this.action = null;
        }
    }

    saveTransparency() {
        if (!this.transparencies) {
            this.transparencies = {};
            for (var uuid in AssetLibrary.objects) {
                const object = AssetLibrary.objects[uuid];
                if (object instanceof THREE.Mesh) {
                    let materials = ensureArray(object.material);
                    for (let material of materials) {
                        this.transparencies[material.uuid] = material.transparent;
                        material.transparent = true;
                    }
                }
            }
        }
    }

    recoverTransparency() {
        if (this.transparencies) {
            for (var uuid in this.transparencies) {
                const object = AssetLibrary.objects[uuid];
                if (object && (object instanceof THREE.Mesh)) {
                    let materials = ensureArray(object.material);
                    for (let material of materials) {
                        material.transparent = this.transparencies[material.uuid];
                    }
                }
            }
            this.transparencies = null;
        }
    }
}

export default MeshIsolation;
export { MeshIsolation };

function createAnimationClip(objectUuids, opacity) {
    const tracks = [];

    for (let uuid in AssetLibrary.objects) {
        if (AssetLibrary.objects.hasOwnProperty(uuid) && objectUuids.indexOf(uuid) === -1) {
            const object = AssetLibrary.objects[uuid];

            if (object instanceof THREE.Mesh) {
                addMeshIsolationProperties(object);
                tracks.push(createMeshOpacityTrack(uuid, opacity));
            }
        }
    }

    return new THREE.AnimationClip('isolation sequence', -1, tracks);
}

function createMeshOpacityTrack(meshUuid, opacity) {
    const times = new Float32Array([0, 1]);
    const values = new Float32Array([opacity, opacity]);

    return new THREE.NumberKeyframeTrack(meshUuid + ".meshIsolationOpacity", times, values);
}

function addMeshIsolationProperties(object) {
    delete object.meshIsolationOpacity;

    let materials = ensureArray(object.material);
    let currentOpacity = materials[0].opacity;

    Object.defineProperty(object, 'meshIsolationOpacity', {
        configurable: true,
        get: () => currentOpacity,
        set: (value) => {
            currentOpacity = value;
            for (let material of materials) {
                material.opacity = value;
            }
        },
    });
}
